// extracted by mini-css-extract-plugin
module.exports = {"input":"PaginationInputFilterField_input__3gWLK"};